import { render, staticRenderFns } from "./DataNaturalRiding.vue?vue&type=template&id=1a3224de&"
import script from "./DataNaturalRiding.vue?vue&type=script&lang=js&"
export * from "./DataNaturalRiding.vue?vue&type=script&lang=js&"
import style0 from "./DataNaturalRiding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports